import React from 'react';
import { connect } from 'react-redux';
import Grow from '@material-ui/core/Grow';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import * as actions from '../../Actions/xpa';
import css from './login.css';


class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      login: true,
      shouldLogin: true,
      hasBookid: true,
      showMessage: false,
    }
  }
  componentDidMount() {
    this.checkBookid();
  }

  checkBookid = () => {
    const bookid = this.props.match.params.bookid;
    if (bookid && bookid !== "null") localStorage.setItem('bookid', bookid);
    else this.setState({ hasBookid: false });
  }

  toggleBox = () => {
    this.setState({
      shouldLogin: !this.state.shouldLogin
    });
    setTimeout(
      () =>
        this.setState({
          login: !this.state.login
        }),
      250
    );
  };

  showMessage = () => {
    this.setState({ showMessage: true });
    this.props.clearXPAState();
  }

  render() {
    const message = [
      `Unknown error occurred, please try again.`, 
      <br />, 
      `If the problem persists, please contact the `, 
      <a className={[css.company, css.noUnderline].join(' ')} href="https://www.reckon.com/au/contact-us/">Reckon Support.</a>
    ];
    if (this.props.xpa.set) {
      this.showMessage()
    }
    return (
      <div className="container">
        <Container className={css.background} component="main" maxWidth="xs">
          <CssBaseline />
          {this.state.login ? (
            <Grow in={this.state.shouldLogin}>
              <div className={css.paper}>
                {this.state.hasBookid ? 
                <LoginForm
                  onToggle={this.toggleBox}/> : 
                  <div className={css.message}>{message}</div>}
              </div>
            </Grow>
          ) : (
            <Grow in={!this.state.shouldLogin}>
              <div className={css.paper}>
                <ResetPasswordForm onToggle={this.toggleBox} />
              </div>
            </Grow>
          )}
        </Container>
        <Snackbar
          className={css.snackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          key={0}
          open={this.state.showMessage}
        >
          <SnackbarContent 
            style={{backgroundColor: "green" }}
            message={<span id="message-id">Password created, please log in.</span>} 
            action={[
              <IconButton key="close" aria-label="close" color="inherit" onClick={() => this.setState({showMessage: false})}>
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Snackbar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { xpa } = state;
  return { xpa };
}

Login = connect(
  mapStateToProps,
  actions
)(Login);

export default Login;



// WEBPACK FOOTER //
// ./src/components/Portal/Login.js